import React, { useState } from 'react';
import '../App.css';
import banner from '../pages/banner.png';
import logo from '../assets/logo.png'; // Update path if needed
import { FaBars, FaTimes } from 'react-icons/fa';

const Home = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="home-page">
      {/* Header */}
      <header>
        <nav className="navbar">
          <a href="/" className="logo">
            <img src={logo} alt="Chaman Hospital" className="logo-img" />
          </a>
          <div className="menu-icon" onClick={toggleMenu}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>
          <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
            <li><a href="/" className="active">Home</a></li>
            <li><a href="/Appointment">Appointment</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/doctors">Doctors</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/login" className="btn-login">Login</a></li>
          </ul>
        </nav>
      </header>

      {/* Hero Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage: `url(${banner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '100px 20px',
          color: 'white',
          textAlign: 'center',
        }}
      >
        <div className="container">
          <h2 style={{ fontSize: '3rem', fontWeight: 'bold' }}>Welcome to Chaman Hospital</h2>
          <p style={{ fontSize: '1.2rem', marginTop: '10px' }}>
            Serving the people of Bahadurgarh, Patiala with dedication, advanced care, and compassion.
          </p>
          <a
            href="/Appointment"
            className="btn-primary"
            style={{
              display: 'inline-block',
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#00bfff',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '5px',
              fontWeight: 'bold',
            }}
          >
            Book Appointment
          </a>
        </div>
      </section>
 




      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <h2>About Chaman Hospital</h2>
          <p>Chaman Hospital is a multi-specialty medical facility located in Bahadurgarh, Patiala. With a team of experienced doctors, state-of-the-art infrastructure, and a commitment to compassionate care, we ensure every patient receives the highest level of treatment and attention.</p>
          <a href="/about" className="btn-secondary">Read More</a>
        </div>
      </section>

      {/* Key Facilities */}
      <section className="facilities-section">
        <div className="container">
          <h2>Our Facilities</h2>
          <ul className="facilities-list">
            <li>✅ 24/7 Emergency & Trauma Services</li>
            <li>✅ Fully Equipped ICU & Operation Theaters</li>
            <li>✅ In-House Pathology & Radiology Labs</li>
            <li>✅ Modern OPD & IPD Services</li>
            <li>✅ Free Treatment with PMKVY Card</li>
            <li>✅ 24/7 Ambulance Services Across Patiala</li>
            <li>✅ Pharmacy & Cafeteria Within Premises</li>
            <li>✅ Advanced Diagnostic Imaging (CT, MRI, X-Ray)</li>
          </ul>
        </div>
      </section>

      {/* Departments Preview */}
      <section className="departments-section">
        <div className="container">
          <h2>Medical Departments</h2>
          <div className="departments-grid">
            <div className="department-card">
              <h3>Cardiology</h3>
              <p>Comprehensive heart care including diagnostics, surgeries & cardiac rehab.</p>
            </div>
            <div className="department-card">
              <h3>Orthopedics</h3>
              <p>Fracture management, joint replacement, and bone health treatments.</p>
            </div>
            <div className="department-card">
              <h3>Gynecology</h3>
              <p>Women's health, maternity care, and advanced surgical solutions.</p>
            </div>
            <div className="department-card">
              <h3>Pediatrics</h3>
              <p>Expert child care, vaccinations, and growth consultations.</p>
            </div>
            <div className="department-card">
              <h3>General Surgery</h3>
              <p>Minor and major surgeries using advanced techniques and care.</p>
            </div>
          </div>
        </div>
      </section>

      {/* PMKVY Card Info */}
      <section className="pmkvy-section">
        <div className="container">
          <h2>PMKVY Card Accepted Here</h2>
          <p>We proudly accept Pradhan Mantri Kaushal Vikas Yojana (PMKVY) health cards. Eligible patients can avail free treatments under this initiative. Visit our reception or call us to know more about the process.</p>
          <a href="/contact" className="btn-primary">Get Free Treatment</a>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="container">
          <h2>What Our Patients Say</h2>
          <div className="testimonial">
            <p>"I received amazing care during my surgery. Doctors and staff were so supportive. Highly recommended!"</p>
            <strong>- Rakesh Kumar, Patiala</strong>
          </div>
          <div className="testimonial">
            <p>"Thanks to PMKVY card, my treatment was fully covered. Grateful to Chaman Hospital for their honest service."</p>
            <strong>- Sunita Devi, Bahadurgarh</strong>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="home-cta">
        <div className="container">
          <h2>Need Immediate Help?</h2>
          <p>Call our 24/7 helpline or visit the emergency wing anytime. Your health is our mission.</p>
          <a href="/contact" className="btn-secondary">Contact Now</a>
          
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <p>© {new Date().getFullYear()} Chaman Hospital, Bahadurgarh, Patiala. All Rights Reserved.</p>
          <p><a href="/login" className="footer-login-link">Login</a></p> {/* Footer Login link */}
        </div>
      </footer>
    </div>
  );
};

export default Home;
